import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orbitLOnboardingDetailKeys } from "Api/Queries/Merchants/useOrbitLOnboardingDetailQuery";
import { orbitLOnboardingListKeys } from "Api/Queries/Merchants/useOrbitLOnboardingListQuery";
import { availableTerminalsKeys } from "Api/Queries/Merchants/useSearchAvailableTerminalsQuery";
import {
  type SwapOrbitLTerminalRequest,
  type SwapOrbitLTerminalResult,
  postMerchantsPublicIDOrbitLSwapTerminal,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  request: SwapOrbitLTerminalRequest;
};

type Props = {
  onSuccess?: (result: SwapOrbitLTerminalResult) => void;
  onError?: () => void;
};

export const useSwapOrbitLTerminalMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID, request }: Parameters) =>
        postMerchantsPublicIDOrbitLSwapTerminal(request, merchantPublicID),
    ),
    onSuccess: (
      result: SwapOrbitLTerminalResult,
      { merchantPublicID }: Parameters,
    ) => {
      queryClient.invalidateQueries({
        queryKey: orbitLOnboardingListKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey:
          orbitLOnboardingDetailKeys.byMerchantPublicId(merchantPublicID),
      });
      queryClient.invalidateQueries({
        queryKey: availableTerminalsKeys.all,
      });
      onSuccess?.(result);
    },
    onError,
  });
};
